import React, { useEffect, useState } from "react";
import styles from "./ModalView.module.css";

function ModalView({
  isOpen,
  onClose,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}) {
  const [shouldRender, setShouldRender] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      setTimeout(() => setIsAnimating(true), 10);
      document.body.style.overflow = "hidden";
    } else {
      setIsAnimating(false);
      setTimeout(() => setShouldRender(false), 300);
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!shouldRender) return null;

  return (
    <div
      className={`${styles.modal} ${
        isAnimating ? styles.modalOpen : styles.modalClosed
      }`}
      onClick={onClose}
    >
      <div
        className={`${styles.modalContent} ${
          isAnimating ? styles.contentOpen : styles.contentClosed
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}

export default ModalView;
